import { DatePipe, AsyncPipe } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { JobStatistics } from '../../interfaces/job-statistics.interface';
import { Link } from '../../interfaces/link.interface';
import { MarketPlaceItem } from '../../interfaces/market-place-item.interface';
import { JobStatisticsService } from '../../services/job-statistics.service';
import { DxoArgumentAxisModule, DxiSeriesModule, DxoCommonSeriesSettingsModule, DxoLabelModule, DxoFormatModule, DxoLegendModule, DxoExportModule, DxoTooltipModule, DxoScaleModule, DxoSliderMarkerModule } from 'devextreme-angular/ui/nested';
import { DxChartModule, DxRangeSelectorModule } from 'devextreme-angular';

@Component({
    selector: 'al-link-edit-statistics',
    templateUrl: './link-edit-statistics.component.html',
    styleUrls: ['./link-edit-statistics.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [DxChartModule, DxoArgumentAxisModule, DxiSeriesModule, DxoCommonSeriesSettingsModule, DxoLabelModule, DxoFormatModule, DxoLegendModule, DxoExportModule, DxoTooltipModule, DxRangeSelectorModule, DxoScaleModule, DxoSliderMarkerModule, AsyncPipe]
})
export class LinkEditStatisticsComponent implements OnInit {
  @Input()
  link: Link;

  jobStatisticData: JobStatistics[] = [];
  jobStatisticsData$: BehaviorSubject<JobStatistics[]> = new BehaviorSubject<JobStatistics[]>([]);

  public selectedStartValue: Date;
  public selectedEndValue: Date;
  public startValue: Date = new Date(2023, 1, 1);
  public endValue: Date = new Date(2023,6,6);

  constructor(private jobStatisticsService: JobStatisticsService, private datePipe: DatePipe) { }

  ngOnInit(): void {
    this.jobStatisticsService.getJobStatistics(this.link.id).subscribe(e => {
      this.jobStatisticData = e;
      this.jobStatisticsData$.next(this.jobStatisticData);

      //Default to the overview of the last month
      const today = new Date();
      this.selectedEndValue = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      this.selectedStartValue = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
    })
  }

  formatDateTime(date: any) {
    return this.datePipe.transform(date, "yyyy-MM-dd")
  }

  handleScaleValueChange(data)
  {
   // this.selectedStartValue = data.value[0]
    //this.selectedEndValue = data.value[1]

    let filteredData = this.jobStatisticData.filter((item: JobStatistics) =>
    new Date(item.jobDateTime) >= new Date(data.value[0]) && new Date(item.jobDateTime) <= new Date(data.value[1])
      );

    this.jobStatisticsData$.next(filteredData)
  }

  data(data: any) {
    console.log(data);
  }

  customizeTooltip = (info: any) => ({
    html: `<div><div class='tooltip-header'>${this.formatDateTime(info.argumentText)}</div>`
      + '<div class=\'tooltip-body\'><div class=\'series-name\'>'
      + `<span class='top-series-name'>${info.seriesName}: ${info.point.value}</span>`
      + '</div></div>',
  });


}
